import { validatePhoneNumber } from './phone-number';
import { MAX_CUSTOM_ATTRIBUTES } from '../configs';

// Splits parsed CSV rows into group members and rejected rows with reasons.
// Extracted from CreateGroup so the validation rules are unit-testable.
export const splitRows = (rows) => {
	const valid = [];
	const invalid = [];

	rows.forEach((row, idx) => {
		const line = idx + 2; // +1 for header, +1 to make it 1-indexed
		const first_name = row.name;
		const last_name = row.surname;
		const contact_number_raw = row.contact_number;

		const custom_attributes = { ...row };
		delete custom_attributes.name;
		delete custom_attributes.surname;
		delete custom_attributes.contact_number;

		const phone = validatePhoneNumber(contact_number_raw);
		const reasons = [];
		if (!first_name) reasons.push('Missing name');
		if (!last_name) reasons.push('Missing surname');
		if (!phone.ok) reasons.push(phone.reason);
		const numCustom = Object.keys(custom_attributes).length;
		if (numCustom > MAX_CUSTOM_ATTRIBUTES) reasons.push(`Too many custom attributes (${numCustom})`);

		if (reasons.length === 0) {
			valid.push({ first_name, last_name, user_id: phone.e164, custom_attributes });
		} else {
			invalid.push({
				line,
				name: first_name || '',
				surname: last_name || '',
				contact_number: contact_number_raw || '',
				reason: reasons.join('; '),
			});
		}
	});

	return { valid, invalid };
};

// RFC 4180 escaping: wrap in quotes when the value contains a comma, quote
// or newline, doubling any embedded quotes.
export const csvEscape = (value) => {
	const s = value === undefined || value === null ? '' : String(value);
	return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const buildErrorsCsv = (invalid) => {
	const header = 'Line,Name,Surname,Contact number,Reason';
	const rows = invalid.map(e => [e.line, e.name, e.surname, e.contact_number, e.reason].map(csvEscape).join(','));
	return [header, ...rows].join('\n');
};
